/**
 * @generated SignedSource<<8bb5a7569d667d21a5c77d24064e9743>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignerDirectoryFirmTile_firm$data = {
  readonly directoryProfile: {
    readonly activeProjectCount: number | null;
    readonly city: string | null;
    readonly country: string | null;
    readonly profilePhoto: string | null;
  } | null;
  readonly name: string | null;
  readonly publicProfile: {
    readonly email: string | null;
    readonly urlLabel: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectoryImageCarousel_firm">;
  readonly " $fragmentType": "DesignerDirectoryFirmTile_firm";
};
export type DesignerDirectoryFirmTile_firm$key = {
  readonly " $data"?: DesignerDirectoryFirmTile_firm$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectoryFirmTile_firm">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignerDirectoryFirmTile_firm",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignFirmDirectoryProfile",
      "kind": "LinkedField",
      "name": "directoryProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "activeProjectCount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "city",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "country",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "profilePhoto",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "DesignFirmPublicProfile",
      "kind": "LinkedField",
      "name": "publicProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "urlLabel",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "email",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DesignerDirectoryImageCarousel_firm"
    }
  ],
  "type": "DirectoryDesignFirm",
  "abstractKey": null
};

(node as any).hash = "7e9684aa97c5b2bdf3b76efbb9ffa6eb";

export default node;
